var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 72,
    viewBox: "0 0 66 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8335 51H27.1665V42.8335H19V31.1665H27.1665V23H38.8335V31.1665H47V42.8335H38.8335V51Z",
    stroke: "currentColor",
    strokeWidth: 5.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35077 57.1241L3.03425 12.717C2.78458 10.9618 3.92458 9.32368 5.6479 8.93907L31.5341 3.1616C32.4997 2.94613 33.5004 2.94613 34.466 3.1616L60.3522 8.93907C62.0755 9.32368 63.2154 10.9618 62.9657 12.717L56.6494 57.1241C56.4105 58.8037 54.9601 69 33.0001 69C11.04 69 9.58967 58.8037 9.35077 57.1241Z",
    stroke: "currentColor",
    strokeWidth: 5.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchild);
export default __webpack_public_path__ + "static/media/schild.3d3c71e7ab80d5e28601321e9c5133af.svg";
export { ForwardRef as ReactComponent };